import React from 'react';
import styles from './DesignEditorBusinessCard.module.css'
import {Col, Row} from "react-bootstrap";
import BusinessCard from "./BusinessCard/BusinessCard";
import BusinessCardParameters from "./BusinessCard/BusinessCardParameters";

const DesignEditorBusinessCard = () => (
    <Row className={styles.editor}>
        <Col lg={8} className={styles.canvas}>
            <BusinessCard/>
        </Col>
        <Col lg={4} className={styles.parameters}>
            <BusinessCardParameters/>
        </Col>
    </Row>
);

export default DesignEditorBusinessCard;
